import { NgModule } from '@angular/core';
import { ColorPickerComponent } from './color-picker.component';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [ColorPickerComponent],
  exports: [ColorPickerComponent],
  imports: [BrowserModule, BrowserAnimationsModule, TranslateModule],
  providers: []
})
export class ColorPickerModule {}



// WEBPACK FOOTER //
// ./src/app/modules/colorPicker/color-picker.module.ts